import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { MapElementSelectionDetail } from './components/MapElementSelectionDetail';
import { MapElementFilter } from "../../../helper/MapElementFilter";
import { Dropdown } from '../../editor/Dropdown';
import { ElementGroup } from './components/BaseElements';
import { BooleanActionDetail } from './components/BooleanActionDetail';
export const AreaTriggerActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: null,
    selectedElement: action.mapElement,
    elementSetter: value => action.setMapElement(value),
    getSelectableElements: MapElementFilter.filterTriggerLabels,
    parameterTypes: ["actions/AreaTriggerValueModel"]
  }), /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(Dropdown, {
    value: action.triggerOnEnter ? "1" : "0",
    onChange: e => action.setTriggerOnEnter(e.target.value === "1")
  }, /*#__PURE__*/React.createElement("option", {
    value: "1"
  }, t("content.answer_enter")), /*#__PURE__*/React.createElement("option", {
    value: "0"
  }, t("content.answer_leave")))), action.triggerOnEnter && action.toggleCheckOnActivation && /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_check_trigger_on_activation"),
    checked: action.checkOnActivation,
    toggle: action.toggleCheckOnActivation.bind(action)
  }), action.triggerOnEnter && action.toggleStopPlayerPath && /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_stop_player_path"),
    checked: action.stopPlayerPath,
    toggle: action.toggleStopPlayerPath.bind(action)
  }));
});